export const stringConstants = {
    confirmPasswordName: 'confirmPassword',
    displayDateFormat: 'MMMM, YYYY',
    valueDateFormat: 'MMMM D, YYYY',
    bySelecting: 'By selecting, you agree to WeatherBug\'s',
    terms: 'Terms of Service',
    legalTermsLink: 'https://www.weatherbug.com/legal/terms',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    privacyPolicyLink: 'https://www.weatherbug.com/legal/privacy',
    passwordName: 'password'
    
};